var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('li',[_c('a',{ref:"link",class:[_vm.activeClass ].concat( _vm.classes),attrs:{"href":_vm.route,"data-modal":_vm.modalAttribute.value,"data-type":_vm.type}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }